var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderArrowPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 34,
    viewBox: "0 0 21 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8533eb",
    fillRule: "evenodd",
    d: "M17.027 0L21 3.967 7.946 17 21 30.033 17.027 34 0 17z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrowPurple);
export default __webpack_public_path__ + "static/media/slider-arrow-purple.83d507d21af1032f6da173ca68b68158.svg";
export { ForwardRef as ReactComponent };